// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"2246d363","334":"ee64ddb9","456":"9291e604","767":"1a72cd51","785":"8113525a"}[chunkId] + ".chunk.js";
};